const endpoints = {
    getConversations: '/admin/messaging/getConversations',
    getConversationMessages: '/admin/messaging/getConversationMessages',
    sendFreeFormMessageToUser: '/admin/messaging/sendFreeFormMessageToUser',
    requestConversationToUser: '/admin/messaging/requestConversationToUser',
    getMessageMedia: '/admin/messaging/getMessageMedia',
}

export {endpoints};